import React, { useState } from "react";
import "./ModalEditField.css";
import { useUpdateProfile } from "../../../hooks/useUpdateProfile";

const SetPasswordModal = ({ onClose, onSave }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [errors, setErrors] = useState([]);

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const { changePassword } = useUpdateProfile();

  function validatePassword(password) {
    const errors = [];
    if (!/[A-Z]/.test(password)) errors.push("Password must include an uppercase letter");
    if (!/[a-z]/.test(password)) errors.push("Password must include a lowercase letter");
    if (!/\d/.test(password)) errors.push("Password must include a number");
    if (!/[@$!%*?&._-]/.test(password)) errors.push("Password must include a special character (@$!%*?&._-)");
    if (password.length < 8) errors.push("Password must be at least 8 characters long");
    return errors;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirm) {
      setErrors(["Passwords do not match"]);
      return;
    }

    const validationErrors = validatePassword(newPassword);
    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      return;
    }

    const success = await changePassword(currentPassword, newPassword);
    if (success) {
      onSave();
    } else {
      setErrors(["Failed to update password. Please check your current password."]);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Set your password</h3>
        <form onSubmit={handleSubmit}>
          <div className="password-input-wrapper">
            <input
              type={showCurrent ? "text" : "password"}
              className="password-input"
              placeholder="Current password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
            {currentPassword && (
              <button
                type="button"
                className="visibility-toggle"
                onClick={() => setShowCurrent(!showCurrent)}
              >
                {showCurrent ? eyeOpenSvg() : eyeClosedSvg()}
              </button>
            )}
          </div>

          <div className="password-input-wrapper">
            <input
              type={showNew ? "text" : "password"}
              className="password-input"
              placeholder="New password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            {newPassword && (
              <button
                type="button"
                className="visibility-toggle"
                onClick={() => setShowNew(!showNew)}
              >
                {showNew ? eyeOpenSvg() : eyeClosedSvg()}
              </button>
            )}
          </div>

          <div className="password-input-wrapper">
            <input
              type={showConfirm ? "text" : "password"}
              className="password-input"
              placeholder="Confirm new password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
            {confirm && (
              <button
                type="button"
                className="visibility-toggle"
                onClick={() => setShowConfirm(!showConfirm)}
              >
                {showConfirm ? eyeOpenSvg() : eyeClosedSvg()}
              </button>
            )}
          </div>

          {errors.length > 0 && (
            <ul style={{ color: "#bdbdbd", fontSize: "0.85rem", marginTop: "8px", marginBottom: "8px" }}>
              {errors.map((err, i) => (
                <li key={i}>{err}</li>
              ))}
            </ul>
          )}

          <div className="modal-buttons">
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="save-btn">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SetPasswordModal;

// Helper SVGs
const eyeOpenSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20">
    <path d="M1 10c2.5-4.5 6.5-7 9-7s6.5 2.5 9 7c-2.5 4.5-6.5 7-9 7s-6.5-2.5-9-7z"
      fill="none" stroke="#8493ad" strokeWidth="1.5" />
    <circle cx="10" cy="10" r="3" fill="none" stroke="#8493ad" strokeWidth="1.5" />
  </svg>
);

const eyeClosedSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20">
    <path d="M1 10c2.5-4.5 6.5-7 9-7s6.5 2.5 9 7c-2.5 4.5-6.5 7-9 7s-6.5-2.5-9-7z"
      fill="none" stroke="#8493ad" strokeWidth="1.5" />
    <circle cx="10" cy="10" r="3" fill="none" stroke="#8493ad" strokeWidth="1.5" />
    <line x1="5" y1="15" x2="15" y2="5" stroke="#8493ad" strokeWidth="1.5" />
  </svg>
);
